import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Page from '../../../components/Page/Page';
import SignupGrid from '../../../components/Home/SignupGrid/SignupGrid';
import { HomeProvider } from '../../context/homeContext';
import getAllHomePageSettings from './getAllHomePageSettings.graphql'
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import s from './Partner.css';

class Partner extends React.Component {

  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings }, data: { getEditStaticPage, loading: staticLoading } } = this.props;
    const { currentLocale } = this.props;

    let homeSettings = {}, dynamicHomePageSettings = [], dynamicStaticContentSettings, content;;
    if (!loading) {
      getAllHomePageSettings && getAllHomePageSettings?.homePageData?.map((item) => {
        if (item?.dynamicHomePageSettings?.length > 0) {
          item?.dynamicHomePageSettings.map((o) => {
            o['name'] = item?.name;
            dynamicHomePageSettings.push(o);
          })
        }
        homeSettings[item?.name] = item?.value
      })
    }

    dynamicStaticContentSettings = getDynamicTitleByLocale({ dynamicHomePageSettings: getEditStaticPage?.result?.dynamicStaticContentSettings, locale: currentLocale });

    content = dynamicStaticContentSettings[0]?.content || getEditStaticPage?.result?.content;

    const pageBanner = getEditStaticPage && getEditStaticPage?.result?.pageBanner

    return (
      <div>
        {!loading && !staticLoading &&
          <div>
            <HomeProvider value={homeSettings}>
              <div className={s.homeBanner} />
              <Page
                html={content}
                pageBanner={pageBanner}
              />

              <SignupGrid dynamicHomePageSettings={dynamicHomePageSettings} currentLocale={currentLocale} />
            </HomeProvider>
          </div>}
      </div>
    );
  }
}

const mapState = (state) => ({
  currentLocale: state?.intl?.locale
});

const mapDispatch = {
};

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch),
  graphql(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  })
)(Partner);
